module.exports = __webpack_public_path__ + "static/media/volaby-original.4b8b1eef.svg";